{#if trackList}
  <div class="col-lg-6 col-radio-tracklist">
    <!--<a href="#" class="tracklist-cover-source font-size-xs">
   <span class="muted">Vir naslovnic - Spotify</span>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 168 168"><path fill="#1ED760" d="M84 .3a83.7 83.7 0 1 0 0 167.5A83.7 83.7 0 0 0 84 .3zM122.4 121a5.2 5.2 0 0 1-7.2 1.7c-19.6-12-44.4-14.7-73.5-8a5.2 5.2 0 0 1-2.4-10.3c32-7.3 59.3-4.1 81.4 9.4a5.2 5.2 0 0 1 1.7 7.2zm10.3-22.8c-2 3-6 4-9 2.1a109.9 109.9 0 0 0-83.5-9.8 6.5 6.5 0 0 1-3.8-12.4c30.4-9.3 68.3-4.8 94.1 11 3 2 4 6 2.1 9zm.8-23.8c-27-16-71.5-17.5-97.3-9.7a7.8 7.8 0 1 1-4.5-15c29.6-9 78.8-7.2 109.8 11.2a7.8 7.8 0 1 1-8 13.5z"></path></svg>
  </a> -->
    <div class="radio-tracklist font-size-sm">
      {#each $returnLastThreeSongs as song}
        <div class="radio-tracklist-item">
          <a href="javascript:void(0)"
            on:click="{() => setStartTimeToCookie(song['ura'],song['artist_name'],song['title_name'] )}"
            class="d-inline-flex align-items-center mb-2"
          >
            <div class="radio-tracklist-cover d-md-none d-lg-none">
              <!-- {#if song['image_link']}
            <img src="{song['image_link']}" alt="Slika posnetka: {song['artist_name']} - {song['title_name']}" width="50" height="50" style="border-radius: 5px;">
            {:else} -->
              <span class="icon-music"></span>
              <!--  {/if} -->
            </div>
            <div class="radio-tracklist-time text-center">
              <span class="icon-play"></span>
              <span class="time muted">{song["ura"]}</span>
            </div>
            <div class="radio-tracklist-title text-uppercase text-truncate">
              <strong>{song["artist_name"]}</strong>
              <span class="muted">- {song["title_name"]}</span>
            </div>
          </a>
        </div>
      {/each}
    </div>
  </div>
{/if}

<script lang="ts">
  import { stationStore } from "../../store";

  const { trackList, returnLastThreeSongs, getCurrentTimeFromBrowser } =
    stationStore;
  import { utils } from "../../services/Utils";
  import { get } from "svelte/store";

  function setStartTimeToCookie(startTime, artist, title) {
    const songName = artist+'-'+title
     // @ts-ignore
    if(typeof _paq !== 'undefined'){
       // @ts-ignore
      _paq.push(['trackEvent', 'S.O.S', songName, 1 ]);
    }
    const $getCurrentTimeFromBrowser = get(getCurrentTimeFromBrowser);
    let secondsSong = utils.HMStoSec1(startTime + ":00");
    const timePassed = $getCurrentTimeFromBrowser - secondsSong;
    // @ts-ignore
    window._globaLiveRadioPlayerCommands.dEvent("E_LIVE_GO_BACK", timePassed);
  }
</script>

<style type="text/scss">
</style>
